// FacebookAdCard.tsx
import { Icon } from "@iconify/react";
import { AdData } from "./ad.types";

interface Props {
  ad: AdData;
}

export default function FacebookAdCard({ ad }: Props) {
  return (
    <article
      dir={ad.language === "rtl" ? "rtl" : "ltr"}
      className="bg-white dark:bg-deepSlate rounded-2xl shadow-fb border border-gray-200
                w-full mx-auto overflow-hidden"
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold dark:text-primary text-tealGreen">
            Advertiser
          </span>
          <span className="text-xs">Sponsored</span>
        </div>

        <button className="p-2 rounded-full hover:bg-fb-hover">
          <Icon icon="mdi:dots-horizontal" className="h-5 w-5" />
        </button>
      </div>

      {/* Image */}
      <a href={ad.link} target="_blank" rel="noopener noreferrer">
        <img
          src={ad.image}
          alt=""
          className="w-full max-h-[360px] object-cover"
        />
      </a>

      {/* Content */}
      <div className="px-4 py-3 space-y-1">
        <h3 className="text-sm font-medium text-fb-text leading-snug line-clamp-3">
          {ad.headline}
        </h3>

        <p className="text-xs text-fb-muted uppercase">
          {ad.domain}
        </p>
      </div>
    </article>
  );
}
